// Product meta descriptions (accordion) + "labs" deep-link behavior.

function initAccordion(root) {
  const titles = root.querySelectorAll(".c-product-meta-desc__title");
  if (!titles.length) return;

  titles.forEach((title) => {
    title.addEventListener("click", () => {
      const item = title.closest(".c-product-meta-desc__item");
      if (!item) return;

      const isActive = item.classList.contains("active");

      root.querySelectorAll(".c-product-meta-desc__item").forEach((el) => {
        el.classList.remove("active");
      });

      if (!isActive) item.classList.add("active");
    });
  });
}

function initLabsLinks() {
  const labLinks = document.querySelectorAll(".js-product-meta-desc-labs");
  const targetAccordion = document.querySelector("#pdp-tab-effects");
  if (!labLinks.length || !targetAccordion) return;

  labLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      document.querySelectorAll(".c-product-meta-desc__item").forEach((item) => {
        item.classList.remove("active");
      });

      targetAccordion.classList.add("active");

      setTimeout(() => {
        const elementPosition = targetAccordion.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 50;

        window.scrollTo({ top: offsetPosition, behavior: "smooth" });
      }, 100);
    });
  });
}

(() => {
  const root = document.querySelector(".c-product-meta-desc");
  if (!root) return;

  initAccordion(root);
  initLabsLinks();
})();

